import { render, staticRenderFns } from "./summary-card.vue?vue&type=template&id=43e4452f&scoped=true"
import script from "./summary-card.vue?vue&type=script&lang=ts"
export * from "./summary-card.vue?vue&type=script&lang=ts"
import style0 from "./summary-card.vue?vue&type=style&index=0&id=43e4452f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e4452f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43e4452f')) {
      api.createRecord('43e4452f', component.options)
    } else {
      api.reload('43e4452f', component.options)
    }
    module.hot.accept("./summary-card.vue?vue&type=template&id=43e4452f&scoped=true", function () {
      api.rerender('43e4452f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/primary-kpi-step/summary/summary-card.vue"
export default component.exports